import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import { receiveKeys } from './keys';

import type { TypePostStatusRequestedParams, TypePostStatusRequestedResponse } from '~/types/receive.types';

const fetchReceivingProgress = async (
  ownerCode: string,
  params: TypePostStatusRequestedParams
): Promise<TypePostStatusRequestedResponse> => {
  const { data } = await axiosInstance.get<TypePostStatusRequestedResponse>(
    `${API_ENDPOINT.RECEIVE.GET_RECEIVING_PROGRESS}/${ownerCode}/progress`,
    { params }
  );
  return data;
};

type TypeUseGetReceivingProgressQueryParams = {
  ownerCode: string;
  params: TypePostStatusRequestedParams;
  enabled?: boolean;
};

/**
 * [입고관리 > 입고현황] 입고현황 목록 조회 Query Hook
 */
export const useGetReceivingProgressQuery = ({
  ownerCode,
  params,
  enabled = true,
}: TypeUseGetReceivingProgressQueryParams) => {
  return useQuery({
    queryKey: receiveKeys.receivingProgress(ownerCode, params),
    queryFn: () => fetchReceivingProgress(ownerCode, params),
    enabled,
    staleTime: 0,
    gcTime: 1000 * 30,
    placeholderData: keepPreviousData,
  });
};
